
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lookbooks/[...slug]",
      function () {
        return require("private-next-pages/lookbooks/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lookbooks/[...slug]"])
      });
    }
  